var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',{attrs:{"two-line":""}},[_c('style-select',{attrs:{"value":_vm.wrapperStyle,"mode":_vm.lessonPlanController.mode,"title":"Wrapper styles"}}),_c('v-divider'),_c('style-select',{attrs:{"value":_vm.slideStyle,"mode":_vm.lessonPlanController.mode,"title":"Slide styles"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }